import { useEffect, useState } from 'react';

/**
 * true, solange die Media-Query zutrifft. Fuer Layout-Entscheidungen in
 * JavaScript (z. B. Szene im Hoch- oder Querformat aufbauen); reine
 * Darstellung gehoert weiter in Tailwind-Breakpoints.
 */
const useMediaQuery = (query) => {
  const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);
  return matches;
};

export default useMediaQuery;
